/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosChecklistItemsCreateChecklistItemRequest,
  FacilityFlowCoreModulesPlanningDtosChecklistItemsReorderChecklistItemsRequest,
  FacilityFlowCoreModulesPlanningDtosChecklistItemsTaskChecklistItemDto,
  FacilityFlowCoreModulesPlanningDtosChecklistItemsUpdateChecklistItemRequest,
  GetApiV1TasksTaskIdChecklistItemsParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getTaskChecklistItems = () => {
/**
 * @summary Checkliste eines Tasks. Standardmäßig ohne deaktivierte Punkte —
der Verwaltungs-Editor setzt `includeInactive=true`.
 */
const getApiV1TasksTaskIdChecklistItems = (
    taskId: string,
    params?: GetApiV1TasksTaskIdChecklistItemsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosChecklistItemsTaskChecklistItemDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosChecklistItemsTaskChecklistItemDto[]>(
      {url: `/api/v1/tasks/${taskId}/checklist-items`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Neuen Checklistenpunkt anlegen; wird ans Ende der Liste gehängt.
 */
const postApiV1TasksTaskIdChecklistItems = (
    taskId: string,
    facilityFlowCoreModulesPlanningDtosChecklistItemsCreateChecklistItemRequest: FacilityFlowCoreModulesPlanningDtosChecklistItemsCreateChecklistItemRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosChecklistItemsTaskChecklistItemDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosChecklistItemsTaskChecklistItemDto>(
      {url: `/api/v1/tasks/${taskId}/checklist-items`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosChecklistItemsCreateChecklistItemRequest
    },
      options);
    }
  /**
 * @summary Checklistenpunkt bearbeiten (Titel, Intervall-Hinweis, Foto-Pflicht, Aktiv-Status).
 */
const putApiV1TasksTaskIdChecklistItemsItemId = (
    taskId: string,
    itemId: string,
    facilityFlowCoreModulesPlanningDtosChecklistItemsUpdateChecklistItemRequest: FacilityFlowCoreModulesPlanningDtosChecklistItemsUpdateChecklistItemRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosChecklistItemsTaskChecklistItemDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosChecklistItemsTaskChecklistItemDto>(
      {url: `/api/v1/tasks/${taskId}/checklist-items/${itemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosChecklistItemsUpdateChecklistItemRequest
    },
      options);
    }
  /**
 * @summary Checklistenpunkt löschen. Wurde er bereits abgehakt, wird er stattdessen
deaktiviert — das Protokoll bleibt als Nachweis erhalten.
 */
const deleteApiV1TasksTaskIdChecklistItemsItemId = (
    taskId: string,
    itemId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tasks/${taskId}/checklist-items/${itemId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Reihenfolge der Checkliste setzen. Die Liste muss alle Punkte des Tasks
genau einmal enthalten; die Position wird zur neuen Sortierung.
 */
const putApiV1TasksTaskIdChecklistItemsOrder = (
    taskId: string,
    facilityFlowCoreModulesPlanningDtosChecklistItemsReorderChecklistItemsRequest: FacilityFlowCoreModulesPlanningDtosChecklistItemsReorderChecklistItemsRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosChecklistItemsTaskChecklistItemDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosChecklistItemsTaskChecklistItemDto[]>(
      {url: `/api/v1/tasks/${taskId}/checklist-items/order`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosChecklistItemsReorderChecklistItemsRequest
    },
      options);
    }
  return {getApiV1TasksTaskIdChecklistItems,postApiV1TasksTaskIdChecklistItems,putApiV1TasksTaskIdChecklistItemsItemId,deleteApiV1TasksTaskIdChecklistItemsItemId,putApiV1TasksTaskIdChecklistItemsOrder}};
export type GetApiV1TasksTaskIdChecklistItemsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTaskChecklistItems>['getApiV1TasksTaskIdChecklistItems']>>>
export type PostApiV1TasksTaskIdChecklistItemsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTaskChecklistItems>['postApiV1TasksTaskIdChecklistItems']>>>
export type PutApiV1TasksTaskIdChecklistItemsItemIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTaskChecklistItems>['putApiV1TasksTaskIdChecklistItemsItemId']>>>
export type DeleteApiV1TasksTaskIdChecklistItemsItemIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTaskChecklistItems>['deleteApiV1TasksTaskIdChecklistItemsItemId']>>>
export type PutApiV1TasksTaskIdChecklistItemsOrderResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTaskChecklistItems>['putApiV1TasksTaskIdChecklistItemsOrder']>>>
